export default function config(moduleName) {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'from_org', label: 'From Org', sortable: true },
    { key: 'period', label: 'Period', sortable: true },
    { key: 'file', label: 'File', sortable: true },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'total_quote_type', label: 'Total quote type', sortable: true },
    { key: 'actions', label: 'Actions' },
  ]
  const tableConfigOptions = { endpoint: `${moduleName}/additionalQuotes` }
  return {
    tableColumns,
    tableConfigOptions,
  }
}
